import React from "react";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import { Box, TextField, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ShipCss from "../Ships/ShipsCss.css";
import { getCookie } from "../../services/Cookies";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  paddingTop: {
    paddingTop: "3em",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  text1: {
    fontSize: "20px",
    fontWeight: "400",
    "& b": {
      fontWeight: "500",
    },
  },

  paper: {
    padding: theme.spacing(2),
    //   textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  boxBorder: {
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  btnPrimary: {
    background: "#ff4717",
    color: "white",
    textTransform: "capitalize",
  },
  shipDatailsText: {
    color: "rgb(32 32 32)",
  },

  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  overflowHidden: {
    overflow: "hidden",
    height: "20px",
  },
  arrowIcons: {
    fontSize: "46px",
    marginTop: "-12px",
  },
}));

export default function ShipDetails(props) {
  const history = useHistory();
  const classes = useStyles();
  const [shipBox, setShipBox] = React.useState(true);
  const serviceTypes = getCookie("serviceTypes").split(',');
  //console.log(serviceTypes)
  const { dataSource, seletedShip } = props;
  return (
    <div>
      <Box component="div" bgcolor="#fff" boxShadow={1} borderRadius={6}>
        <Box
          component="div"
          bgcolor="#1A1A31"
          py={1.0}
          px={3}
          fontWeight={600}
          fontSize={15}
          color="#fff"
          className={classes.boxBorder}
        >
          <Box display="flex" className={classes.justifyContentBetween}>
            <Box component="span" fontSize="18px">
              Ship Details
            </Box>
            <Box
              component="span"
              width="0.03"
              className={classes.overflowHidden}
            >
              <Box display={shipBox ? "inline" : "none"} component="span">
                <ArrowDropDownIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setShipBox(!shipBox);
                  }}
                />
              </Box>

              <Box display={!shipBox ? "inline" : "none"} component="span">
                <ArrowDropUpIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setShipBox(!shipBox);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box component="div" px={3} display={shipBox ? "block" : "none"}>
          <Grid container style={{paddingTop: "20px"}}>
            <Grid item md={4}>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Ship Name : </b>
                {seletedShip.currentVesselName ? seletedShip.currentVesselName : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText ? classes.shipDatailsText : ""}>IMO : </b>
                {seletedShip.imono}
              </p>
              {/*<p className={classes.text1}>
                <b className={classes.shipDatailsText}>Vessel Key : </b>
                {seletedShip.vesselKey?seletedShip.vesselKey:""}
                </p>*/}
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Object No :</b>
                {seletedShip.objNum ? seletedShip.objNum : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Flag :</b>
                {seletedShip.flag ? seletedShip.flag : ""}
              </p>
            </Grid>
            <Grid item md={4}>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Ship Owner : </b>
                {seletedShip.shipOwner ? seletedShip.shipOwner : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>DWT Range : </b>
                {seletedShip.dwtRange ? seletedShip.dwtRange : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Year Built : </b>
                {seletedShip.yearBuilt ? seletedShip.yearBuilt : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Shipyard :</b>
                {seletedShip.shipyard ? seletedShip.shipyard : ""}
              </p>
            </Grid>
            <Grid item md={4}>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Operator :</b>
                {seletedShip.operator ? seletedShip.operator : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Ship Type :</b>
                <b>{seletedShip.shiptype ? seletedShip.shiptype : ""}</b>
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Classification :</b>
                {seletedShip.classification ? seletedShip.classification : ""}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Status : </b>
                {seletedShip.status ? seletedShip.status : ""}
              </p>
            </Grid>
            <Grid item xs={12} className="text-center" >
              {/*{serviceTypes[4]=="OCM" || "Lube Analysis"? <Button
                variant="contained"
                color=""
                className={classes.btnPrimary}
                onClick={() => {
                  history.push({
                    pathname: `/dashboard/assets/${"ship"}/${seletedShip.vesselKey}`,
                    data: seletedShip
                  });
                }}
              >
                View Equipments
              </Button>:""}*/}
              {/* {serviceTypes.map((serviceType) => {
                return serviceType == "Lube Analysis" ? <Button
                  variant="contained"
                  color=""
                  className={classes.btnPrimary}
                  onClick={() => {
                    history.push({
                      pathname: `/dashboard/assets/${"ship"}/${seletedShip.vesselKey}`,
                      data: seletedShip
                    });
                  }}
                >
                  View Equipments
                </Button> : ""
              })} */}

              <Box py={2}></Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
